module.exports = __webpack_public_path__ + "img/icon2.5bc4f731.png";